import { SectionStyle } from '@website-builder/model/structure/section/section-style';

export class HeaderSectionStyle extends SectionStyle {
  boxShadow = '';
  visible = 'uk-visible@s';
  mobileVisible = 'uk-hidden@s';
  logoPosition = 'uk-navbar-right';
  togglePosition = 'uk-navbar-left';
  toggleStyle = '';
  showToggleText = false;
  popupBackground = 'uk-background-default';
  centerText = '';
  centerTextVertically = '';
  popupTextStyle = 'uk-color-primary';
  mobileFontSize = '';
  mobileFontFamily = '';
  popupHoverStyle = '';

  static normalize(styles: Partial<HeaderSectionStyle>): HeaderSectionStyle {
    const sectionStyle: SectionStyle = SectionStyle.normalize(styles);
    const pureStyles = new HeaderSectionStyle();

    Object.assign(pureStyles, sectionStyle);

    pureStyles.boxShadow = styles.boxShadow ?? pureStyles.boxShadow;
    pureStyles.visible = styles.visible ?? pureStyles.visible;
    pureStyles.mobileVisible = styles.mobileVisible ?? pureStyles.mobileVisible;
    pureStyles.logoPosition = styles.logoPosition ?? pureStyles.logoPosition;
    pureStyles.togglePosition = styles.togglePosition ?? pureStyles.togglePosition;
    pureStyles.toggleStyle = styles.toggleStyle ?? pureStyles.toggleStyle;
    pureStyles.showToggleText = styles.showToggleText ?? pureStyles.showToggleText;
    pureStyles.popupBackground = styles.popupBackground ?? pureStyles.popupBackground;
    pureStyles.centerText = styles.centerText ?? pureStyles.centerText;
    pureStyles.centerTextVertically = styles.centerTextVertically ?? pureStyles.centerTextVertically;
    pureStyles.popupTextStyle = styles.popupTextStyle ?? pureStyles.popupTextStyle;
    pureStyles.mobileFontSize = styles.mobileFontSize ?? pureStyles.mobileFontSize;
    pureStyles.mobileFontFamily = styles.mobileFontFamily ?? pureStyles.mobileFontFamily;
    pureStyles.popupHoverStyle = styles.popupHoverStyle ?? pureStyles.popupHoverStyle;

    return pureStyles;
  }
}
